var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-qrcode-container"},[_c('a',{attrs:{"href":_vm.picUrl,"download":_vm.picName}},[_c('el-button',{staticClass:"setBtn",attrs:{"size":"small"},on:{"click":_vm.handleDownloadQrCode}},[_vm._v(_vm._s(_vm.downloadBtnText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }